module.exports = __webpack_public_path__ + "assets/img/authent.92f6b1dc.png";